import { render } from "./loanNotesComponent.vue?vue&type=template&id=45e71bce"
import script from "./loanNotesComponent.vue?vue&type=script&lang=js"
export * from "./loanNotesComponent.vue?vue&type=script&lang=js"

import "./loanNotesComponent.vue?vue&type=style&index=0&id=45e71bce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__